import Vue from 'vue';
import Router from 'vue-router';

import loop from './views/loop';
import home from './views/home';
import info from './views/info';
import plans from './views/plans';
import products from './views/products';
import orderConfirm from './views/orderConfirm';//wx订单确认并支付页面
import orderConfirmH5 from './views/orderConfirmH5';//h5订单确认页面
import orderConfirmH5Next from './views/orderConfirmH5Next';//h5支付页面
import rescindPage from './views/rescindPage';//解约记录
import payEnd from './views/payEnd';
import result from './views/result';
import personalCenter from './views/personalCenter';
import orderLIst from './views/orderLIst';
import integralList from './views/integralList';
import auth from './views/auth';
import replacementCard from './views/replacementCard';
import collarFlow from './views/collarFlow';
import enjoyDetails from './views/enjoyDetails';
import invoiceOrder from './views/invoiceManage/invoiceOrder';
import invoiceXx from './views/invoiceManage/invoiceXx';
import invoiceDetails from './views/invoiceManage/invoiceDetails';

import userLogin from './views/userCenter/userLogin';
import userCenterPersona from './views/userCenter/userCenterPersona';
import userMeal from './views/userCenter/userMeal';
import uesrOrderQr from './views/userCenter/uesrOrderQr';
import userBalance from './views/userCenter/userBalance';
import userIntegral from './views/userCenter/userIntegral';
import userRedeem from './views/userCenter/userRedeem';
import userOrderList from './views/userCenter/userOrderList';
import userInvoiceList from './views/userCenter/userInvoiceList';
import userPointsDetails from './views/userCenter/userPointsDetails';

import cardInfo from './views/international/cardInfo';
import cardPlans from './views/international/cardPlans';
import cardPayEnd from './views/international/cardPayEnd';
import cardLoop from './views/international/cardLoop';
import userAgreement from './views/international/userAgreement';
import orderList from './views/international/orderList';

//短信充值
import msgProduct from './views/msg/msgProduct';
//短信发送
import msgSend from './views/msg/msgSend';

Vue.use(Router)
const myRouter = new Router({
    mode: 'hash',
    routes: [
        {
            path: '*',
            redirect: '/loop'
        },
        {
            path: '/loop',
            name: 'loop',
            components: {
                default: loop,
            },
        },
        {
            path: '/home',
            name: 'home',
            components: {
                default: home,
            },
        },
        {
            path: '/info',
            name: 'info',
            components: {
                default: info,
            },
        },
        {
            path: '/plans',
            name: 'plans',
            components: {
                default: plans,
            },
        },
        {
            path: '/products',
            name: 'products',
            components: {
                default: products,
            },
        },
        {
            path: '/orderConfirm',
            name: 'orderConfirm',
            components: {
                default: orderConfirm,
            },
        },
        {
            path: '/orderConfirmH5',
            name: 'orderConfirmH5',
            components: {
                default: orderConfirmH5,
            },
        },
        {
            path: '/orderConfirmH5Next',
            name: 'orderConfirmH5Next',
            components: {
                default: orderConfirmH5Next,
            },
        },
        {
            path: '/rescindPage',
            name: 'rescindPage',
            components: {
                default: rescindPage,
            },
        },
        {
            path: '/result',
            name: 'result',
            components: {
                default: result,
            },
        },
        {
            path: '/payEnd',
            name: 'payEnd',
            components: {
                default: payEnd,
            },
        },
        {
            path: '/personalCenter',
            name: 'personalCenter',
            components: {
                default: personalCenter,
            },
        },
        {
            path: '/orderLIst',
            name: 'orderLIst',
            components: {
                default: orderLIst,
            },
        },
        {
            path: '/integralList',
            name: 'integralList',
            components: {
                default: integralList,
            },
        },
        {
            path: '/auth',
            name: 'auth',
            components: {
                default: auth,
            },
        },
        {
            path: '/replacementCard',
            name: 'replacementCard',
            components: {
                default: replacementCard,
            },
        },
        {
            path: '/collarFlow',
            name: 'collarFlow',
            components: {
                default: collarFlow,
            },
        },
        {
            path: '/enjoyDetails',
            name: 'enjoyDetails',
            components: {
                default: enjoyDetails,
            },
        },
        {
            path: '/invoiceManage/invoiceOrder',
            name: 'invoiceOrder',
            components: {
                default: invoiceOrder,
            },
        },
        {
            path: '/invoiceManage/invoiceXx',
            name: 'invoiceXx',
            components: {
                default: invoiceXx,
            },
        },
        {
            path: '/invoiceManage/invoiceDetails',
            name: 'invoiceDetails',
            components: {
                default: invoiceDetails,
            },
        },
        {
            path: '/userCenter/userLogin',
            name: 'userLogin',
            components: {
                default: userLogin,
            },
        },
        {
            path: '/userCenter/userCenterPersona',
            name: 'userCenterPersona',
            components: {
                default: userCenterPersona,
            },
        },
        {
            path: '/userCenter/userMeal',
            name: 'userMeal',
            components: {
                default: userMeal,
            },
        },
        {
            path: '/userCenter/uesrOrderQr',
            name: 'uesrOrderQr',
            components: {
                default: uesrOrderQr,
            },
        },
        {
            path: '/userCenter/userBalance',
            name: 'userBalance',
            components: {
                default: userBalance,
            },
        },
        {
            path: '/userCenter/userIntegral',
            name: 'userIntegral',
            components: {
                default: userIntegral,
            },
        },
        {
            path: '/userCenter/userRedeem',
            name: 'userRedeem',
            components: {
                default: userRedeem,
            },
        },
        {
            path: '/userCenter/userOrderList',
            name: 'userOrderList',
            components: {
                default: userOrderList,
            },
        },
        {
            path: '/userCenter/userInvoiceList',
            name: 'userInvoiceList',
            components: {
                default: userInvoiceList,
            },
        },
        {
            path: '/userCenter/userPointsDetails',
            name: 'userPointsDetails',
            components: {
                default: userPointsDetails,
            },
        },
        {
            path: '/international/cardInfo',
            name: 'cardInfo',
            components: {
                default: cardInfo,
            },cardPlans
        },
        {
            path: '/international/cardPlans',
            name: 'cardPlans',
            components: {
                default: cardPlans,
            },
        },
        {
            path: '/international/cardPayEnd',
            name: 'cardPayEnd',
            components: {
                default: cardPayEnd,
            },
        },
        {
            path: '/international/cardLoop',
            name: 'cardLoop',
            components: {
                default: cardLoop,
            },
        },
        {
            path: '/international/userAgreement',
            name: 'userAgreement',
            components: {
                default: userAgreement,
            },
        },
        {
            path: '/international/orderList',
            name: 'orderList',
            components: {
                default: orderList,
            },
        },
        {
            path: '/msg/product',
            name: 'msgProduct',
            components: {
                default: msgProduct,
            },
        },
        {
            path: '/msg/send',
            name: 'msgSend',
            components: {
                default: msgSend,
            },
        },
    ]
})
export default myRouter
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}